import React from "react";
import PageHeader from "../../components/PageHeader";
import {
  Row,
  Col,
  ColCard,
  CardTitle,
  CardSubtitle,
  CardHeader,
  CardUnit,
} from "../../components/ContentLayout";
import { SIZES } from "../../constants/SIZE";

const TestContentLayout = (props) => {
  return (
    <div className="test-page ">
      <PageHeader title="WeCake - Content Layout" />

      <ColCard>
        <CardTitle>ContentLayout Tags</CardTitle>
        <br />
        <CardSubtitle className="mb-3">
          Row, Col, Card, CardBody, CardHeader, CardTitle, CardUnit
        </CardSubtitle>
        <br />

        <Row>
          <Col sm="12">
            <Row>
              <ColCard>
                <CardHeader>
                  <CardTitle>CardTitle</CardTitle>
                  <CardUnit>CardUnit</CardUnit>
                </CardHeader>
                CardBody
              </ColCard>
            </Row>
          </Col>
        </Row>
      </ColCard>
      <ColCard>
        <CardTitle>ContentLayout Grid</CardTitle>
        <br />
        <CardSubtitle className="mb-3">Row, Col ,ColCard</CardSubtitle>
        <br />

        <Row>
          <Col sm="8">
            <Row>
              <ColCard>left - top</ColCard>
            </Row>
            <Row>
              <ColCard sm="6">left - Bottom - Left</ColCard>
              <ColCard sm="6">left - Bottom -Right</ColCard>
            </Row>
          </Col>
          {/* contents Right */}
          <Col sm="4">
            <Row>
              <ColCard sm="12">Right -Top</ColCard>
              <ColCard sm="12">Right - Bottom</ColCard>
            </Row>
          </Col>
        </Row>
      </ColCard>

      <ColCard>
        <CardTitle>ColCard Style</CardTitle>
        <br />
        <CardSubtitle className="mb-3">
          Default, Light, Simple, Dim
        </CardSubtitle>
        <br />
        <Row>
          <ColCard sm="6">Default</ColCard>
          <ColCard sm="6">Default</ColCard>
        </Row>
        <Row type={"Light"}>
          <ColCard sm="6" type={"Light"}>
            Light
          </ColCard>
          <ColCard sm="6" type={"Light"}>
            Light
          </ColCard>
        </Row>
        <Row type={"simple"}>
          <ColCard sm="6" type={"simple"}>
            Simple
          </ColCard>
          <ColCard sm="6" type={"simple"}>
            Simple
          </ColCard>
        </Row>
        <Row type={"dim"}>
          <ColCard sm="6" type={"dim"}>
            Dim
          </ColCard>
          <ColCard sm="6" type={"dim"}>
            Dim
          </ColCard>
        </Row>
      </ColCard>

      <ColCard>
        <CardTitle>ColCard Size</CardTitle>
        <br />
        <CardSubtitle className="mb-3">xl, lg, md, sm</CardSubtitle>
        <br />
        {SIZES.map(({ label }, idx) => (
          <Row size={label} key={idx}>
            <ColCard sm="6" size={label}>
              {label}
            </ColCard>
            <ColCard sm="6" size={label}>
              {label}
            </ColCard>
          </Row>
        ))}
      </ColCard>
    </div>
  );
};

export default TestContentLayout;
